export const getQueryParams = (search: string) => {
  const params = new URLSearchParams(search);
  return {
    parentId: params.get('parentId') || '',
  };
};
